<script>
    import { onMount } from "svelte";
    import MediaQuery from "./components/MediaQuery.svelte";
    import { fade, fly } from "svelte/transition";
    var data = [];
    var map = "";
    var currentMarkers = [];
    let results = [];
    //Store map properties
    var storedBounds;
    var storedPadding;
    var resultsText = "";
    var notFound = "";
    var inputPlace = "";
    var inputCoords = [];
    var button = "map";
    var mapVisibility = false;
    var showList = true;
    onMount(async () => {
        data["zip"] = window.location.search.substr(1).replace("zip=", "");
        if (data["zip"] && data["zip"] !== "") {
            geoLocatePlace();
        } else {
            window.location.href = "https://www.zaggfranchise.com/stores";
        }
    });
    async function geoLocatePlace() {
        const suggestionResponse = await fetch(
            `https://api.mapbox.com/geocoding/v5/mapbox.places/` +
                data["zip"] +
                `.json?country=us,ca,pr&types=postcode,address,locality,neighborhood,place&language=en&limit=8&autocomplete=false&access_token=pk.eyJ1IjoiZnJvbnRwb3IiLCJhIjoiY2tsOGhwdm45MGgzMzJvbXYwM3hrd3NoYyJ9.5PF5iNRZ9sMEU2PVtRaUPA`,
        );
        const geoCoded = await suggestionResponse.json();
        const bestMatch = geoCoded.features[0].geometry.coordinates;
        inputPlace = geoCoded.features[0].place_name;
        inputCoords = bestMatch;
        getLocs(bestMatch);
    }

    async function getLocs(coords) {
        let call = await fetch(
            `/wp-json/locations/geo?lat=${coords[1]}&lng=${coords[0]}`,
        );
        let response = await call.json();
        data["locations"] = response;
        results = response;
        displayMap();
    }

    function displayMap() {
        mapboxgl.accessToken =
            "pk.eyJ1IjoiZnJvbnRwb3IiLCJhIjoiY2tsOGhwdm45MGgzMzJvbXYwM3hrd3NoYyJ9.5PF5iNRZ9sMEU2PVtRaUPA";
        map = new mapboxgl.Map({
            container: "locsmap",
            style: "mapbox://styles/mapbox/light-v10",
            center: [-96, 37.8],
            zoom: 2,
            pitch: 15,
            bearing: 25,
            // animate: false
        });
        var options = {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0,
        };
        map.scrollZoom.disable();
        map.addControl(new mapboxgl.NavigationControl());

        setMarkers();
    }
    function setMarkers() {
        if (data["locations"].length === 0) {
            notFound =
                "There are no locations in your search area. Please try a different search zip code or city.";
            resultsText = "No Results Found";
            //   window.dataLayer = window.dataLayer || [];
            //   dataLayer.push({
            //     event: "locationSearch",
            //     searchStatus: "noResults",
            //     searchTerm: place
            //   });
            const lng = inputCoords[0];
            const lat = inputCoords[1];
            map.flyTo({
                center: [lng, lat],
                zoom: 7,
                bearing: 0,
            });
        } else if (data["locations"].length === 1) {
            resultsText = "We've found 1 Nearby Location";
            //   window.dataLayer = window.dataLayer || [];
            //   dataLayer.push({
            //     event: "locationSearch",
            //     searchStatus: "Search",
            //     searchTerm: document.getElementById("mb-zip-search").value
            //   });
        } else {
            resultsText = `We've found ${data["locations"].length} Nearby Locations`;
            //   window.dataLayer = window.dataLayer || [];
            //   dataLayer.push({
            //     event: "locationSearch",
            //     searchStatus: "Search",
            //     searchTerm: document.getElementById("mb-zip-search").value
            //   });
        }
        var bounds = new mapboxgl.LngLatBounds();
        if (currentMarkers !== null) {
            for (var i = currentMarkers.length - 1; i >= 0; i--) {
                currentMarkers[i].remove();
            }
        }
        let locations = data["locations"];

        locations.forEach(function (marker, i) {
            // create a HTML element for each feature
            var el = document.createElement("div");

            el.className = "ppmarker";
            el.innerHTML = "<span></span>";
            // make a marker for each feature and add to the map
            var oneMarker = new mapboxgl.Marker(el)
                .setLngLat(marker.coordinates)
                .addTo(map)
                .setPopup(
                    new mapboxgl.Popup({
                        offset: 25,
                    }) // add popups
                        .setHTML(
                            `<div class="brPop">

                ${
                    marker.url
                        ? `<a href="https://www.zaggfranchise.com/${marker.url}/" target="_blank">
                    <h6>` +
                          marker.name +
                          `</h6>
                </a>`
                        : `<h6>` + marker.name + `</h6>`
                }
                <p class="text-black">

                    ${marker.address}<br/>
                    ${marker.address2 ? marker.address2 + "<br/>" : ""}
                    ${marker.city}, ${marker.state} ${marker.zip + "<br/>"}
                    ${
                        marker.additional
                            ? `<span class="italic text-[10px]">` +
                              marker.additional +
                              "<br />" +
                              `</span>`
                            : ""
                    }

                    ${`<div class='items-center mt-3 md:flex gap-x-2 lg:gap-x-3'>
                        
                        ${
                            marker.comming
                                ? ` <span class='inline-flex px-2 py-1 mt-2 font-bold comming bg-primary text-dark-1'>Coming Soon</span> `
                                : `

                        ${
                            marker.phone
                                ? `<a
                        class="block mb-3 font-bold text-black md:inline-block hover:text-gray-500 md:mb-0"
                        href="tel:${marker.phone}" data-linktype="local">
                          <svg class="inline-block" fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><clipPath id="a"><path d="m0 0h20v20h-20z"/></clipPath><g clip-path="url(#a)"><path d="m5.83335 3.33329v13.33331h8.33335v-13.33331zm-.83333-1.66666h9.99998c.221 0 .433.08779.5893.24407s.2441.36825.2441.58926v15.00004c0 .221-.0878.4329-.2441.5892s-.3683.2441-.5893.2441h-9.99998c-.22101 0-.43297-.0878-.58926-.2441-.15628-.1563-.24407-.3682-.24407-.5892v-15.00004c0-.22101.08779-.43298.24407-.58926.15629-.15628.36825-.24407.58926-.24407zm4.99998 12.49997c.221 0 .433.0878.5893.2441s.2441.3682.2441.5893c0 .221-.0878.4329-.2441.5892s-.3683.2441-.5893.2441c-.22099 0-.43295-.0878-.58923-.2441-.15629-.1563-.24408-.3682-.24408-.5892 0-.2211.08779-.433.24408-.5893.15628-.1563.36824-.2441.58923-.2441z" fill="#aa182c"/></g></svg>
                        Phone »
                      </a>`
                                : ""
                        }

                        ${
                            marker.url
                                ? `<a class="flex items-center mb-2 font-semibold text-black hover:text-gray-700 gap-x-1 md:mb-0" data-linktype="OutboundLocal" href="https://www.zaggfranchise.com/${marker.url}/" target="_blank">
                          <svg fill="none" height="18" viewBox="0 0 18 18" width="18" xmlns="http://www.w3.org/2000/svg"><path d="m13.5 8.115c-.1989 0-.3897.07905-.5303.21967-.1406.14063-.2197.33143-.2197.53033v5.385c0 .1989-.0791.3897-.2197.5303s-.3314.2197-.5303.2197h-8.25c-.19891 0-.38968-.0791-.53033-.2197s-.21967-.3314-.21967-.5303v-8.25c0-.19891.07902-.38968.21967-.53033s.33142-.21967.53033-.21967h5.385c.1989 0 .3897-.07902.53033-.21967.14062-.14065.21967-.33142.21967-.53033s-.07905-.38968-.21967-.53033c-.14063-.14065-.33143-.21967-.53033-.21967h-5.385c-.59674 0-1.16903.23705-1.59099.65901s-.65901.99425-.65901 1.59099v8.25c0 .5967.23705 1.169.65901 1.591.42196.4219.99425.659 1.59099.659h8.25c.5967 0 1.169-.2371 1.591-.659.4219-.422.659-.9943.659-1.591v-5.385c0-.1989-.0791-.3897-.2197-.53033-.1406-.14062-.3314-.21967-.5303-.21967zm2.94-6.15c-.0761-.18326-.2218-.3289-.405-.405-.0902-.03843-.187-.05881-.285-.06h-4.5c-.1989 0-.3897.07902-.5303.21967s-.2197.33142-.2197.53033.0791.38968.2197.53033.3314.21967.5303.21967h2.6925l-7.725 7.7175c-.0703.0697-.12609.1527-.16417.2441s-.05768.1894-.05768.2884.0196.197.05768.2884.09387.1744.16417.2441c.06972.0703.15267.1261.24407.1642.09139.0381.18942.0577.28843.0577s.19704-.0196.28843-.0577c.0914-.0381.17435-.0939.24407-.1642l7.7175-7.725v2.6925c0 .19891.0791.38968.2197.53033s.3314.21967.5303.21967.3897-.07902.5303-.21967.2197-.33142.2197-.53033v-4.5c-.0012-.09801-.0216-.19484-.06-.285z" fill="#aa182c"/></svg>
                          Website »
                        </a>`
                                : ` <a
                        class="block mt-2 mb-2 font-bold text-black md:inline-block hover:text-gray-700 md:mb-0"
                        data-linktype="OutboundLocal"
                        href="mailto:${marker.email}">
                        <svg fill="none" height="18" viewBox="0 0 18 18" width="18" xmlns="http://www.w3.org/2000/svg"><g stroke="#aa182c" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="m3 3h12c.825 0 1.5.675 1.5 1.5v9c0 .825-.675 1.5-1.5 1.5h-12c-.825 0-1.5-.675-1.5-1.5v-9c0-.825.675-1.5 1.5-1.5z"/><path d="m16.5 4.5-7.5 5.25-7.5-5.25"/></g></svg>
                        Email »
                      </a>`
                        }

                    ${`<a
                      class="inline-flex items-center font-bold text-black gap-x-1 hover:text-gray-500"
                      href="https://www.google.com/maps/dir/current+location/${marker.name}/" target='_blank' data-linktype="get-directions" data-storename="${marker.stateName} - ${marker.name}">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M0.459501 5.98625C0.0680007 5.85575 0.0642507 5.645 0.467001 5.51075L14.7822 0.73925C15.179 0.60725 15.4062 0.82925 15.2952 1.21775L11.2048 15.5322C11.0923 15.929 10.8635 15.9425 10.6955 15.566L8 9.5L12.5 3.5L6.5 8L0.459501 5.98625Z" fill="#AA182C" />
                      </svg>
                      Get Directions »
                    </a>`}
                       
                        `
                        } 

                      </div>`}
                </p>
               </div>`,
                        ),
                );

            currentMarkers.push(oneMarker);
            bounds.extend(marker.coordinates);
        });
        //move the map to the new bounds
        if (locations.length == 1) {
            storedBounds = bounds;
            storedPadding = pad;

            map.flyTo({
                center: locations[0].coordinates,
                zoom: 14,
                speed: 1,
                pitch: 45,
                bearing: -20,
            });
        } else if (locations.length > 1) {
            //change padding to prevent animation fail
            const mq = window.matchMedia("(min-width: 1280px)");
            if (mq.matches) {
                // window width is at least 1280px
                var pad = {
                    top: 80,
                    bottom: 80,
                    left: 80,
                    right: 80,
                };
            } else {
                // window width is less than 1280px
                var pad = {
                    top: 80,
                    bottom: 80,
                    left: 80,
                    right: 80,
                };
            }
            map.fitBounds(bounds, {
                padding: pad,
                speed: 1,
                pitch: 45,
                bearing: -20,
                antialias: true,
            });
            storedBounds = bounds;
            storedPadding = pad;
        } else {
            map.fitBounds(bounds, {
                padding: pad,
                speed: 1,
                pitch: 45,
                bearing: -20,
                antialias: true,
            });
            storedBounds = bounds;
            storedPadding = pad;
        }
    }

    function resetBounds() {
        map.fitBounds(storedBounds, {
            padding: storedPadding,
            speed: 1,
            pitch: 45,
            bearing: -20,
            antialias: true,
        });
    }
    function flyToPlace(coords, marker) {
        map.setBearing(-20);
        map.setPitch(45);
        map.flyTo({
            center: coords,
            zoom: 14,
            pitch: 15,
            bearing: 0,
        });
        var popUps = document.getElementsByClassName("mapboxgl-popup");
        // Check if there is already a popup on the map and if so, remove it
        if (popUps[0]) popUps[0].remove();

        var popup = new mapboxgl.Popup({ closeOnClick: true, offset: 25 })
            .setLngLat(coords)
            .setHTML(
                `<div class="brPop sec">
                ${
                    marker.url
                        ? `<a href="https://www.zaggfranchise.com/${marker.url}/" target="_blank">
                    <h6>` +
                          marker.name +
                          `</h6>
                </a>`
                        : `<h6>` + marker.name + `</h6>`
                }
                <p class="text-black">
                    ${marker.address}<br/>
                    ${marker.address2 ? marker.address2 + "<br/>" : ""}
                    ${marker.city}, ${marker.state} ${marker.zip + "<br/>"}
                    ${
                        marker.additional
                            ? `<span class="italic text-[10px]">` +
                              marker.additional +
                              "<br />" +
                              `</span>`
                            : ""
                    }
                    
                         ${`<div class='items-center mt-3 md:flex gap-x-2 lg:gap-x-3'>
                        
                        ${
                            marker.comming
                                ? ` <span class='inline-flex px-2 py-1 mt-2 font-bold comming bg-primary text-dark-1'>Coming Soon</span> `
                                : `

                        ${
                            marker.phone
                                ? `<a
                        class="block mb-3 font-bold text-black md:inline-block hover:text-gray-500 md:mb-0"
                        href="tel:${marker.phone}" data-linktype="local">
<svg class="inline-block" fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><clipPath id="a"><path d="m0 0h20v20h-20z"/></clipPath><g clip-path="url(#a)"><path d="m5.83335 3.33329v13.33331h8.33335v-13.33331zm-.83333-1.66666h9.99998c.221 0 .433.08779.5893.24407s.2441.36825.2441.58926v15.00004c0 .221-.0878.4329-.2441.5892s-.3683.2441-.5893.2441h-9.99998c-.22101 0-.43297-.0878-.58926-.2441-.15628-.1563-.24407-.3682-.24407-.5892v-15.00004c0-.22101.08779-.43298.24407-.58926.15629-.15628.36825-.24407.58926-.24407zm4.99998 12.49997c.221 0 .433.0878.5893.2441s.2441.3682.2441.5893c0 .221-.0878.4329-.2441.5892s-.3683.2441-.5893.2441c-.22099 0-.43295-.0878-.58923-.2441-.15629-.1563-.24408-.3682-.24408-.5892 0-.2211.08779-.433.24408-.5893.15628-.1563.36824-.2441.58923-.2441z" fill="#aa182c"/></g></svg>
                        Phone »
                      </a>`
                                : ""
                        }

                        ${
                            marker.url
                                ? `<a class="flex items-center mb-2 font-semibold text-black hover:text-gray-700 gap-x-1 md:mb-0" data-linktype="OutboundLocal" href="https://www.zaggfranchise.com/${marker.url}/" target="_blank">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.45001 1.0636C8.09856 0.712136 7.52869 0.712136 7.17722 1.0636L0.877218 7.3636C0.52575 7.71508 0.52575 8.28494 0.877218 8.63639C1.22869 8.98784 1.79854 8.98784 2.15002 8.63639L2.41362 8.37278V14.3C2.41362 14.7971 2.81656 15.2 3.31362 15.2H5.11362C5.61067 15.2 6.01362 14.7971 6.01362 14.3V11.6C6.01362 11.1029 6.01362 10.25 7.10005 10.25H8.21655H8.71362C9.61362 10.25 9.61362 11.1029 9.61362 11.6V14.3C9.61362 14.7971 10.0165 15.2 10.5136 15.2H12.3136C12.8107 15.2 13.2136 14.7971 13.2136 14.3V8.37278L13.4772 8.63639C13.8287 8.98784 14.3986 8.98784 14.75 8.63639C15.1015 8.28494 15.1015 7.71508 14.75 7.3636L8.45001 1.0636Z" fill="#AA182C"/>
                          </svg>
                          Website »
                        </a>`
                                : ` <a
                        class="block mt-2 mb-2 font-bold text-black md:inline-block hover:text-gray-700 md:mb-0"
                        data-linktype="OutboundLocal"
                        href="mailto:${marker.email}">
                        <svg fill="none" height="18" viewBox="0 0 18 18" width="18" xmlns="http://www.w3.org/2000/svg"><g stroke="#aa182c" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="m3 3h12c.825 0 1.5.675 1.5 1.5v9c0 .825-.675 1.5-1.5 1.5h-12c-.825 0-1.5-.675-1.5-1.5v-9c0-.825.675-1.5 1.5-1.5z"/><path d="m16.5 4.5-7.5 5.25-7.5-5.25"/></g></svg>
                        Email »
                      </a>`
                        }

                    ${`<a
                      class="inline-flex items-center font-bold text-black gap-x-1 hover:text-gray-500"
                      href="https://www.google.com/maps/dir/current+location/${marker.name}/" target='_blank' data-linktype="get-directions" data-storename="${marker.stateName} - ${marker.name}">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M0.459501 5.98625C0.0680007 5.85575 0.0642507 5.645 0.467001 5.51075L14.7822 0.73925C15.179 0.60725 15.4062 0.82925 15.2952 1.21775L11.2048 15.5322C11.0923 15.929 10.8635 15.9425 10.6955 15.566L8 9.5L12.5 3.5L6.5 8L0.459501 5.98625Z" fill="#AA182C" />
                      </svg>
                      Get Directions »
                    </a>`}
                       
                        `
                        } 

                      </div>`}

                </p>
               </div>`,
            )
            .addTo(map);

        popup.on("close", function (e) {
            resetBounds();
        });
    }
    function mapChanger() {
        if (mapVisibility == true) {
            mapVisibility = false;
            showList = true;
            button = "map";
        } else {
            mapVisibility = true;
            showList = false;
            button = "list";
        }
    }
</script>

<div class="container pb-16 mx-auto">
    <div class="flex flex-wrap mb-10">
        <div class="w-full font-bold md:px-4 md:w-1/2">
            <h1 class="locator--main-title">Find a ZAGG Store</h1>
            <span class="text-md">{resultsText}</span>
        </div>

        <div class="w-full text-right form-input md:w-1/2">
            <form
                action="/stores-search/"
                class="relative block w-full form__locations"
            >
                <input
                    name="zip"
                    placeholder="Enter Your Zip Code"
                    bind:value={inputPlace}
                    on:focus={(e) => (e.target.value = "")}
                    class="relative block pl-5 mt-6 md:w-full md:px-5 md:pr-5 pr-14 md:mt-0"
                />
                <button
                    type="submit"
                    class="absolute send__button top-4 right-4"
                >
                    <img
                        src="/wp-content/themes/zagg/img/send--color.svg"
                        alt="send"
                        width="25"
                        height="25"
                    />
                </button>
            </form>
        </div>
    </div>

    <div class="w-full md:flex">
        <div class="block w-full mx-auto md:w-1/2 w-12/12 md:pl-4">
            <ul class="pl-20 pr-0 list lg:pr-10">
                {#if results != ""}
                    {#each results as result}
                        <MediaQuery query="(min-width: 550px)" let:matches>
                            {#if matches}
                                <li
                                    class:hideList={!showList}
                                    class="mbloc-block"
                                    transition:fade
                                >
                                    <span class="miles"
                                        >{result.distance} Mi</span
                                    >
                                    <h4>
                                        {result.name}
                                        <small
                                            class="ml-5"
                                            on:click={flyToPlace(
                                                result.coordinates,
                                                result,
                                            )}
                                        >
                                            View on Map
                                        </small>
                                    </h4>
                                    <p class="leading-tighter">
                                        {result.address}
                                        {#if result.address2}
                                            <br />
                                            {result.address2}
                                        {/if}
                                        <br />
                                        {result.city}, {result.state}
                                        {result.zip}

                                        {#if result.additional !== '' && result.additional !== null}
                                            <div class="flex gap-1 items-start mt-2">
                                                <svg class="inline-block mr-1" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M5.79812 6.53208C5.60346 6.53208 5.41678 6.60941 5.27913 6.74705C5.14149 6.8847 5.06416 7.07138 5.06416 7.26604V10.2019H6.53208V8H8.73396V9.8349L11.3028 7.26604L8.73396 4.69718V6.53208H5.79812ZM8.51891 0.214893L15.7851 7.48109C15.9227 7.61873 16 7.80538 16 8C16 8.19462 15.9227 8.38127 15.7851 8.51891L8.51891 15.7851C8.38127 15.9227 8.19462 16 8 16C7.80538 16 7.61873 15.9227 7.48109 15.7851L0.214893 8.51891C0.0772972 8.38127 0 8.19462 0 8C0 7.80538 0.0772972 7.61873 0.214893 7.48109L7.48109 0.214893C7.61873 0.0772972 7.80538 0 8 0C8.19462 0 8.38127 0.0772972 8.51891 0.214893Z" fill="#AA182C"/>
                                                </svg>
                                                <span class="text-sm">
                                                    {result.additional}
                                                </span>
                                            </div>
                                            <br/>
                                        {/if}
                                    </p>
                                    <p class="block mr-2 lg:inline-flex">
                                        {#if result.comming}
                                            <span
                                                class="px-4 py-2 font-bold comming bg-primary text-dark-1"
                                                >Coming Soon</span
                                            >
                                        {:else}
                                            {#if result.phone}
                                                <a
                                                    class="block mb-2 font-bold text-black lg:inline-block hover:text-gray-500 lg:mb-0"
                                                    data-linktype="local"
                                                    data-locationid={result.url}
                                                    data-storename={result.name}
                                                    href="tel:{result.phone}"
                                                >
                                                    <svg
                                                        class="inline-block"
                                                        fill="none"
                                                        height="20"
                                                        viewBox="0 0 20 20"
                                                        width="20"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        xmlns:xlink="http://www.w3.org/1999/xlink"
                                                        ><clipPath id="a"
                                                            ><path
                                                                d="m0 0h20v20h-20z"
                                                            /></clipPath
                                                        ><g clip-path="url(#a)"
                                                            ><path
                                                                d="m5.83335 3.33329v13.33331h8.33335v-13.33331zm-.83333-1.66666h9.99998c.221 0 .433.08779.5893.24407s.2441.36825.2441.58926v15.00004c0 .221-.0878.4329-.2441.5892s-.3683.2441-.5893.2441h-9.99998c-.22101 0-.43297-.0878-.58926-.2441-.15628-.1563-.24407-.3682-.24407-.5892v-15.00004c0-.22101.08779-.43298.24407-.58926.15629-.15628.36825-.24407.58926-.24407zm4.99998 12.49997c.221 0 .433.0878.5893.2441s.2441.3682.2441.5893c0 .221-.0878.4329-.2441.5892s-.3683.2441-.5893.2441c-.22099 0-.43295-.0878-.58923-.2441-.15629-.1563-.24408-.3682-.24408-.5892 0-.2211.08779-.433.24408-.5893.15628-.1563.36824-.2441.58923-.2441z"
                                                                fill="#aa182c"
                                                            /></g
                                                        ></svg
                                                    >
                                                    Phone
                                                </a>
                                            {/if}

                                            {#if result.url}
                                                <a
                                                    class="flex items-center mb-2 font-bold text-black gap-x-1 lg:ml-6 hover:text-gray-700 lg:mb-0"
                                                    data-linktype="OutboundLocal"
                                                    href="https://www.zaggfranchise.com/{result.url}/"
                                                >
                                                    <svg
                                                        fill="none"
                                                        height="18"
                                                        viewBox="0 0 18 18"
                                                        width="18"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        ><path
                                                            d="m13.5 8.115c-.1989 0-.3897.07905-.5303.21967-.1406.14063-.2197.33143-.2197.53033v5.385c0 .1989-.0791.3897-.2197.5303s-.3314.2197-.5303.2197h-8.25c-.19891 0-.38968-.0791-.53033-.2197s-.21967-.3314-.21967-.5303v-8.25c0-.19891.07902-.38968.21967-.53033s.33142-.21967.53033-.21967h5.385c.1989 0 .3897-.07902.53033-.21967.14062-.14065.21967-.33142.21967-.53033s-.07905-.38968-.21967-.53033c-.14063-.14065-.33143-.21967-.53033-.21967h-5.385c-.59674 0-1.16903.23705-1.59099.65901s-.65901.99425-.65901 1.59099v8.25c0 .5967.23705 1.169.65901 1.591.42196.4219.99425.659 1.59099.659h8.25c.5967 0 1.169-.2371 1.591-.659.4219-.422.659-.9943.659-1.591v-5.385c0-.1989-.0791-.3897-.2197-.53033-.1406-.14062-.3314-.21967-.5303-.21967zm2.94-6.15c-.0761-.18326-.2218-.3289-.405-.405-.0902-.03843-.187-.05881-.285-.06h-4.5c-.1989 0-.3897.07902-.5303.21967s-.2197.33142-.2197.53033.0791.38968.2197.53033.3314.21967.5303.21967h2.6925l-7.725 7.7175c-.0703.0697-.12609.1527-.16417.2441s-.05768.1894-.05768.2884.0196.197.05768.2884.09387.1744.16417.2441c.06972.0703.15267.1261.24407.1642.09139.0381.18942.0577.28843.0577s.19704-.0196.28843-.0577c.0914-.0381.17435-.0939.24407-.1642l7.7175-7.725v2.6925c0 .19891.0791.38968.2197.53033s.3314.21967.5303.21967.3897-.07902.5303-.21967.2197-.33142.2197-.53033v-4.5c-.0012-.09801-.0216-.19484-.06-.285z"
                                                            fill="#aa182c"
                                                        /></svg
                                                    >

                                                    Website
                                                </a>
                                            {:else}
                                                <a
                                                    class="block mb-2 font-bold text-black lg:inline-block lg:ml-6 hover:text-gray-700 lg:mb-0"
                                                    data-linktype="OutboundLocal"
                                                    href="mailto:{result.email}"
                                                >
                                                    <svg
                                                        fill="none"
                                                        height="18"
                                                        viewBox="0 0 18 18"
                                                        width="18"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        ><g
                                                            stroke="#aa182c"
                                                            stroke-linecap="round"
                                                            stroke-linejoin="round"
                                                            stroke-width="2"
                                                            ><path
                                                                d="m3 3h12c.825 0 1.5.675 1.5 1.5v9c0 .825-.675 1.5-1.5 1.5h-12c-.825 0-1.5-.675-1.5-1.5v-9c0-.825.675-1.5 1.5-1.5z"
                                                            /><path
                                                                d="m16.5 4.5-7.5 5.25-7.5-5.25"
                                                            /></g
                                                        ></svg
                                                    >
                                                    Email
                                                </a>
                                            {/if}

                                            <a
                                                class="inline-flex items-center mb-2 font-bold text-black gap-x-2 lg:ml-6 hover:text-gray-700 lg:mb-0"
                                                data-linktype="get-directions"
                                                data-storename="{result.stateName} - {result.name}"
                                                href="https://www.google.com/maps/dir/current+location/{result.name}/"
                                                target="_blank"
                                            >
                                                <svg
                                                    width="16"
                                                    height="16"
                                                    viewBox="0 0 16 16"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M0.459501 5.98625C0.0680007 5.85575 0.0642507 5.645 0.467001 5.51075L14.7822 0.73925C15.179 0.60725 15.4062 0.82925 15.2952 1.21775L11.2048 15.5322C11.0923 15.929 10.8635 15.9425 10.6955 15.566L8 9.5L12.5 3.5L6.5 8L0.459501 5.98625Z"
                                                        fill="#AA182C"
                                                    />
                                                </svg>
                                                Get Directions
                                            </a>
                                        {/if}
                                    </p>
                                </li>
                            {:else}
                                <li
                                    class="mbloc-block"
                                    transition:fade
                                    class:hideList={!showList}
                                >
                                    <span class="miles"
                                        >{result.distance} Mi</span
                                    >
                                    <h4 style="padding-right: 85px !important">
                                        {result.name}
                                    </h4>
                                    <p class="leading-tighter">
                                        {result.address}
                                        {#if result.address2}
                                            <br />
                                            {result.address2}
                                        {/if}
                                        <br />
                                        {result.city}, {result.state}
                                        {result.zip}
                                    </p>
                                    <p class="block mr-2 md:inline-block">
                                        {#if results.comming}
                                            <span
                                                class="px-4 py-2 font-bold comming bg-primary text-dark-1"
                                                >Coming Soon</span
                                            >
                                        {:else}
                                            {#if result.phone}
                                                <a
                                                    class="block mb-2 font-bold text-black md:inline-block hover:text-gray-500 md:mb-0"
                                                    data-linktype="local"
                                                    data-locationid={result.url}
                                                    data-storename={result.name}
                                                    href="tel:{result.phone}"
                                                >
                                                    <svg
                                                        class="inline-block"
                                                        fill="none"
                                                        height="20"
                                                        viewBox="0 0 20 20"
                                                        width="20"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        xmlns:xlink="http://www.w3.org/1999/xlink"
                                                        ><clipPath id="a"
                                                            ><path
                                                                d="m0 0h20v20h-20z"
                                                            /></clipPath
                                                        ><g clip-path="url(#a)"
                                                            ><path
                                                                d="m5.83335 3.33329v13.33331h8.33335v-13.33331zm-.83333-1.66666h9.99998c.221 0 .433.08779.5893.24407s.2441.36825.2441.58926v15.00004c0 .221-.0878.4329-.2441.5892s-.3683.2441-.5893.2441h-9.99998c-.22101 0-.43297-.0878-.58926-.2441-.15628-.1563-.24407-.3682-.24407-.5892v-15.00004c0-.22101.08779-.43298.24407-.58926.15629-.15628.36825-.24407.58926-.24407zm4.99998 12.49997c.221 0 .433.0878.5893.2441s.2441.3682.2441.5893c0 .221-.0878.4329-.2441.5892s-.3683.2441-.5893.2441c-.22099 0-.43295-.0878-.58923-.2441-.15629-.1563-.24408-.3682-.24408-.5892 0-.2211.08779-.433.24408-.5893.15628-.1563.36824-.2441.58923-.2441z"
                                                                fill="#aa182c"
                                                            /></g
                                                        ></svg
                                                    >
                                                    Phone
                                                </a>
                                            {/if}

                                            {#if result.url}
                                                <a
                                                    class="flex items-center mb-2 font-bold text-black gap-x-2 md:ml-6 hover:text-gray-700 md:mb-0"
                                                    data-linktype="OutboundLocal"
                                                    href="https://www.zaggfranchise.com/{result.url}/"
                                                >
                                                    <svg
                                                        fill="none"
                                                        height="18"
                                                        viewBox="0 0 18 18"
                                                        width="18"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        ><path
                                                            d="m13.5 8.115c-.1989 0-.3897.07905-.5303.21967-.1406.14063-.2197.33143-.2197.53033v5.385c0 .1989-.0791.3897-.2197.5303s-.3314.2197-.5303.2197h-8.25c-.19891 0-.38968-.0791-.53033-.2197s-.21967-.3314-.21967-.5303v-8.25c0-.19891.07902-.38968.21967-.53033s.33142-.21967.53033-.21967h5.385c.1989 0 .3897-.07902.53033-.21967.14062-.14065.21967-.33142.21967-.53033s-.07905-.38968-.21967-.53033c-.14063-.14065-.33143-.21967-.53033-.21967h-5.385c-.59674 0-1.16903.23705-1.59099.65901s-.65901.99425-.65901 1.59099v8.25c0 .5967.23705 1.169.65901 1.591.42196.4219.99425.659 1.59099.659h8.25c.5967 0 1.169-.2371 1.591-.659.4219-.422.659-.9943.659-1.591v-5.385c0-.1989-.0791-.3897-.2197-.53033-.1406-.14062-.3314-.21967-.5303-.21967zm2.94-6.15c-.0761-.18326-.2218-.3289-.405-.405-.0902-.03843-.187-.05881-.285-.06h-4.5c-.1989 0-.3897.07902-.5303.21967s-.2197.33142-.2197.53033.0791.38968.2197.53033.3314.21967.5303.21967h2.6925l-7.725 7.7175c-.0703.0697-.12609.1527-.16417.2441s-.05768.1894-.05768.2884.0196.197.05768.2884.09387.1744.16417.2441c.06972.0703.15267.1261.24407.1642.09139.0381.18942.0577.28843.0577s.19704-.0196.28843-.0577c.0914-.0381.17435-.0939.24407-.1642l7.7175-7.725v2.6925c0 .19891.0791.38968.2197.53033s.3314.21967.5303.21967.3897-.07902.5303-.21967.2197-.33142.2197-.53033v-4.5c-.0012-.09801-.0216-.19484-.06-.285z"
                                                            fill="#aa182c"
                                                        /></svg
                                                    >
                                                    Website
                                                </a>
                                            {:else}
                                                <a
                                                    class="block mb-2 font-bold text-black md:inline-block md:ml-6 hover:text-gray-700 md:mb-0"
                                                    data-linktype="OutboundLocal"
                                                    href="mailto:{result.email}"
                                                >
                                                    <svg
                                                        fill="none"
                                                        height="18"
                                                        viewBox="0 0 18 18"
                                                        width="18"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        ><g
                                                            stroke="#aa182c"
                                                            stroke-linecap="round"
                                                            stroke-linejoin="round"
                                                            stroke-width="2"
                                                            ><path
                                                                d="m3 3h12c.825 0 1.5.675 1.5 1.5v9c0 .825-.675 1.5-1.5 1.5h-12c-.825 0-1.5-.675-1.5-1.5v-9c0-.825.675-1.5 1.5-1.5z"
                                                            /><path
                                                                d="m16.5 4.5-7.5 5.25-7.5-5.25"
                                                            /></g
                                                        ></svg
                                                    >
                                                    Email
                                                </a>
                                            {/if}

                                            <a
                                                class="flex items-center mb-2 font-bold text-black gap-x-2 lg:ml-6 hover:text-gray-700 lg:mb-0"
                                                data-linktype="get-directions"
                                                data-storename="{result.stateName} - {result.name}"
                                                href="https://www.google.com/maps/dir/current+location/{result.name}/"
                                                target="_blank"
                                            >
                                                <svg
                                                    width="16"
                                                    height="16"
                                                    viewBox="0 0 16 16"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M0.459501 5.98625C0.0680007 5.85575 0.0642507 5.645 0.467001 5.51075L14.7822 0.73925C15.179 0.60725 15.4062 0.82925 15.2952 1.21775L11.2048 15.5322C11.0923 15.929 10.8635 15.9425 10.6955 15.566L8 9.5L12.5 3.5L6.5 8L0.459501 5.98625Z"
                                                        fill="#AA182C"
                                                    />
                                                </svg>
                                                Get Directions
                                            </a>
                                        {/if}
                                    </p>
                                </li>
                            {/if}
                        </MediaQuery>
                    {/each}
                    <p
                        class="inline-block px-5 py-2 mt-5 text-gray-700 bg-gray-200"
                    >
                        <small>Area searched: 250 Mi Radius</small>
                    </p>
                {:else}
                    <p class="text-sm lg:pr-20">
                        There are no locations in your search area. Please try a
                        different search zip code or city.
                    </p>
                {/if}
            </ul>
        </div>
        <div class="map-holder md:w-1/2 md:pl-6" class:showmap={mapVisibility}>
            <div id="locsmap" />
        </div>
        <MediaQuery query="(max-width: 550px)" let:matches>
            {#if matches}
                <span class="toggler" on:click={mapChanger}>
                    <svg
                        width="16px"
                        height="14px"
                        viewBox="0 0 16 14"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                    >
                        <g
                            id="Page-1"
                            stroke="none"
                            stroke-width="1"
                            fill="none"
                            fill-rule="evenodd"
                        >
                            <g
                                id="iPhone-XS-Max"
                                transform="translate(-121.000000, -862.000000)"
                                fill="#000000"
                                fill-rule="nonzero"
                            >
                                <g
                                    id="repeat"
                                    transform="translate(121.000000, 862.000000)"
                                >
                                    <polygon
                                        id="Path"
                                        points="14.3701 2.99993 9.8701 5.598 9.8701 3.99993 2.88989
                    3.99993 2.88989 7.9999 0.88989 7.9999 0.88989 1.99993 9.8701
                    1.99993 9.8701 0.40186"
                                    />
                                    <polygon
                                        id="Path"
                                        points="6.1299 11.9999 15.1101 11.9999 15.1101 5.9999
                    13.1101 5.9999 13.1101 9.9999 6.1299 9.9999 6.1299 8.4019
                    1.62988 10.9999 6.1299 13.598"
                                    />
                                </g>
                            </g>
                        </g>
                    </svg>
                    Switch to {button == "list" ? "List" : "Map"} View
                </span>
            {/if}
        </MediaQuery>
    </div>
</div>

<style lang="postcss">
    :global(.search-block #mb-zip-search) {
        padding-top: 28px !important;
        padding-bottom: 12px !important;
        background: white;
        border-radius: 5px !important;
        border: 1px solid #e8e8e8;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12);
        box-sizing: border-box;
    }
    :global(a) {
        outline: none !important;
    }
    #locsmap {
        height: 620px;
    }

    :global(.mapboxgl-popup) {
        top: 20px !important;
        left: 15px !important;
    }
    :global(.mapboxgl-popup-content) {
        width: auto;
        min-width: 340px;

        padding: 25px 25px !important;
        box-sizing: border-box;
    }

    @media (max-width: 550px) {
        :global(.mapboxgl-popup-content) {
            min-width: 230px;
        }
    }

    :global(.mapboxgl-popup-tip) {
        border-top-color: #aa182c !important;
        left: -5px !important;
    }
    :global(.brPop) {
        text-align: left;
        box-sizing: border-box;
    }
    :global(.brPop h6) {
        font-size: 16px;
        line-height: 24px;
        font-weight: 600;
        margin: 0;
        outline: none !important;
    }
    :global(.brPop p) {
        margin: 3px 0;
    }
    :global(.ppmarker) {
        width: 0;
        height: 0;
        margin-left: 4px !important;
    }
    :global(.ppmarker b) {
        transform: rotateZ(135deg);
    }
    :global(.mapboxgl-popup-close-button) {
        padding: 8px !important;
    }
    :global(.ppmarker span) {
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        width: 22px;
        height: 28px;
        margin-top: -28px;
        background: url("/wp-content/themes/zagg/img/pin-map--color.svg")
            no-repeat top left;
        background-size: 22px 28px;
        cursor: pointer;
        transform-origin: 0 0;
    }
    .list {
        margin-left: 0px;
        height: 620px;
        box-sizing: border-box;
        margin: 0;
        padding: 0;
        overflow-y: auto;
    }

    .list li:before {
        display: none !important;
    }
    .list li {
        /* Rectangle 122 */
        border: 1px solid #f4f5fa;
        box-shadow:
            0px 10px 11px rgba(243, 246, 255, 0.4),
            0px 0px 30px -9px rgba(206, 206, 206, 0.15);
        border-radius: 4px;
        padding: 2rem;
        margin-bottom: 20px;
    }
    @media (min-width: 451px) and (max-width: 767px) {
        .list {
            padding-left: 10px;
            margin-bottom: 20px;
            height: 40vh;
        }
        .list li {
            width: 100%;
            margin-right: 10px;
            display: inline-block;
        }
    }
    @media (max-width: 450px) {
        .list {
            height: inherit;
            overflow: visible;
        }
        .list li {
            padding-right: 0px;
            display: block;
        }
    }
    .mbloc-block {
        position: relative;
        display: block;
        box-sizing: border-box;
        padding: 10px 20px 30px 0;
        border-bottom: 1px solid #e9e9e9;
        width: 94%;
    }
    .mbloc-block .miles {
        position: absolute;
        top: 10px;
        right: 20px;
        color: #a5b0b9;
        background: #e2e9ef;
        border-radius: 17.5px;
        padding: 1px 8px;
        font-size: 11px;
        font-weight: 600;
    }
    .mbloc-block h4 {
        font-weight: 600;
        font-size: 20px;
        padding-right: 100px;
    }
    .mbloc-block h4 small {
        font-weight: 400;
        font-size: 12px;
        text-decoration: underline;
    }
    .mbloc-block h4 small:hover {
        cursor: pointer;
    }
    :global(.popupwebbtn) {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        box-sizing: border-box;
        padding: 10px 12px !important;
        font-size: 11px !important;
        border-bottom-left-radius: 3px;
        border-bottom-right-radius: 3px;
        display: block;
    }
    @media (max-width: 550px) {
        .map-holder.showmap {
            max-height: 100vh;
        }
        .map-holder {
            max-height: 0px;
            overflow: hidden;
            transition: max-height ease-in 0.3s;
        }
    }
    .toggler {
        padding: 15px 10px;
        background: #aa182c;
        color: black;
        font-size: 12px;
        position: fixed;
        bottom: 0px;
        left: 0px;
        width: 100%;
        z-index: 40;
        text-transform: uppercase;
        font-weight: 900;
        text-align: center;
    }
    .toggler svg {
        display: inline-block;
        margin-right: 6px;
    }
    :global(.hideList) {
        display: none !important;
    }
    .locator--main-title {
        font-size: 2.5rem !important;
    }

    .font-results {
        font-size: 14px;
    }
</style>
